import { useEffect, useState } from "react";
import { isWebDriver } from "../navigator";

export const getSubdomain = () => {
  if (window.location.host.includes("localhost") || isWebDriver()) {
    return "hortis-local";
  }
  const hostname = window.location.hostname;
  const parts = hostname.split(".");
  const subdomain = parts[0];
  return parts.length >= 3 && subdomain != null ? subdomain : null;
};

export const useSubdomain = () => {
  const [subdomain, setSubdomain] = useState<string | null>(null);

  useEffect(() => {
    setSubdomain(getSubdomain());
  }, []);

  return subdomain;
};
